import React from 'react';
import { useTranslation } from 'react-i18next';
import { map } from 'lodash-es';
import { MobileCardRowsProps } from '@dev/ee-components';
import { LandingPage } from '@dev/ee-api/ee-api-models';
import { ViewButtonComponent } from '../components/ViewButtonComponent';

export const useMobileTableRows = (landingPagesList: LandingPage[]): MobileCardRowsProps[] => {
    const { t } = useTranslation();

    return map(landingPagesList, (landingPage: LandingPage) => {
        const linkWithoutProtocol = landingPage.LandingUrl?.replace("https://", "") || '';

        return {
            id: landingPage.Name,
            tableTitle: landingPage.Name,
            link: linkWithoutProtocol || t('nolinkset'),
            view: <ViewButtonComponent landingPage={landingPage} />,
        }
    });
}
